import { render } from "./CancelConfirm.vue?vue&type=template&id=6f3f71b5"
import script from "./CancelConfirm.vue?vue&type=script&lang=js"
export * from "./CancelConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script